import { HeadersAuth, HeadersNoAuth, HTTP, IHttpResponse } from "./http";
import {
	UPDATE_CUSTOMER,
	UPDATE_CUSTOMER_EXTERNAL_COMMS,
	GET_CUSTOMER_BRANDING,
	GET_CUSTOMER_BRANDING_ONBOARD,
	GET_CUSTOMER_CREDITS,
	GET_ALL_CUSTOMER_CREDITS,
	GET_CUSTOMER_BRANDING_EXTERNAL,
	GET_CUSTOMER_BRANDING_DOCUMENT,
	NOTIFICATION_PREFERENCES,
	GET_ALL_CUSTOMER_DOCUMENTS,
	GET_CUSTOMER_DOCUMENTS,
	GET_CUSTOMER_ONBOARDING_DOCUMENTS,
	GET_CUSTOMER_ONBOARDING_DOCUMENTS_DOCUMENTS,
	UPDATE_CUSTOMER_DOCUMENTS,
	UPDATE_TABLE_CONFIG,
	GET_TABLE_CONFIG,
	UPDATE_CUSTOMER_OCCUPATIONS,
	GET_CUSTOMER_OCCUPATIONS,
	GET_CUSTOMER_OCCUPATIONS_ONBOARDING,
	UPDATE_ORGANISATION_REFERENCE,
	GET_ORGANISATION_REFERENCE,
} from "../../config/endpoints";
import { IEmailNotificationPreference } from "../../_models/data.emailPreference";
import { ICustomerSelectDocument } from "../../components/forms/me/candidateComplianceDocuments";
import { IColumnConfig, ITableConfig } from "../../components/forms/me/candidateComplianceConfig";
import { TableTypeEnum } from "../../_enums/tableType.enum";
import { IExternalComms } from "../../_models/data.externalComms.model";
import { IOccupation } from "../../components/forms/me/occupationConfig";
import { OrganisationReferenceItem, OrganisationReferenceResponse } from "../../_models/data.organisationReference.model";

export const UpdateCustomer = (Token: string, DATA, CUSTOMER_ID) => {
	return HTTP({
		Method: "PUT",
		Url: UPDATE_CUSTOMER(CUSTOMER_ID),
		Data: DATA ?? null,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const UpdateCustomerExternalComms = (Token: string, DATA: IExternalComms) => {
	return HTTP({
		Method: "PUT",
		Url: UPDATE_CUSTOMER_EXTERNAL_COMMS,
		Data: DATA ?? null,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCustomerBranding = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CUSTOMER_BRANDING,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCustomerBrandingOnboard = (CANDIDATE_ID, Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CUSTOMER_BRANDING_ONBOARD(CANDIDATE_ID, Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const GetCustomerBrandingExternal = (CANDIDATE_ID, Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CUSTOMER_BRANDING_EXTERNAL(CANDIDATE_ID, Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const GetCustomerBrandingDocument = (CANDIDATE_ID, Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CUSTOMER_BRANDING_DOCUMENT(CANDIDATE_ID, Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const GetCustomerCredits = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CUSTOMER_CREDITS,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetNotificationPreferences = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: NOTIFICATION_PREFERENCES,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const UpdateNotificationPreferences = (Token: string, DATA: IEmailNotificationPreference) => {
	return HTTP({
		Method: "PUT",
		Url: NOTIFICATION_PREFERENCES,
		Headers: HeadersAuth(Token),
		Data: DATA,
	}) as Promise<IHttpResponse>;
};

export const GetAllCustomerCredits = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_ALL_CUSTOMER_CREDITS,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetAllCustomerDocuments = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_ALL_CUSTOMER_DOCUMENTS,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCustomerDocuments = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CUSTOMER_DOCUMENTS,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCustomerOnboardingDocuments = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CUSTOMER_ONBOARDING_DOCUMENTS(Token),
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCustomerOnboardingDocumentsDocuments = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CUSTOMER_ONBOARDING_DOCUMENTS_DOCUMENTS(Token),
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const UpdateCustomerDocuments = (Token: string, DATA: { documents: ICustomerSelectDocument[] }) => {
	return HTTP({
		Method: "PUT",
		Url: UPDATE_CUSTOMER_DOCUMENTS,
		Headers: HeadersAuth(Token),
		Data: DATA,
	}) as Promise<IHttpResponse>;
};

export const GetTableConfig = (Token: string, tableId: TableTypeEnum) => {
	return HTTP({
		Method: "GET",
		Url: GET_TABLE_CONFIG(tableId),
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const UpdateTableConfig = (Token: string, tableId: TableTypeEnum, DATA: { columns: IColumnConfig[]; fixedColumns: string[] }) => {
	return HTTP({
		Method: "PUT",
		Url: UPDATE_TABLE_CONFIG(tableId),
		Headers: HeadersAuth(Token),
		Data: DATA ?? null,
	}) as Promise<IHttpResponse>;
};

export const GetCustomerOccupations = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CUSTOMER_OCCUPATIONS,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCustomerOccupationsOnboarding = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CUSTOMER_OCCUPATIONS_ONBOARDING(Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const UpdateCustomerOccupations = (Token: string, DATA: { occupations: IOccupation[] }) => {
	return HTTP({
		Method: "PUT",
		Url: UPDATE_CUSTOMER_OCCUPATIONS,
		Headers: HeadersAuth(Token),
		Data: DATA ?? null,
	}) as Promise<IHttpResponse>;
};

export const GetOrganisationReference = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_ORGANISATION_REFERENCE,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse<OrganisationReferenceResponse>>;
};

export const UpdateOrganisationReference = (
	Token: string,
	DATA: {
		references: OrganisationReferenceItem[];
	}
) => {
	return HTTP({
		Method: "PUT",
		Url: UPDATE_ORGANISATION_REFERENCE,
		Headers: HeadersAuth(Token),
		Data: DATA ?? null,
	}) as Promise<IHttpResponse<OrganisationReferenceResponse>>;
};
